import { useState } from "react";
import { usePageTitle } from "../hooks/usePageTitle";
import Footer from "../components/Footer";
import FaqsHeaderSection from "../components/FaqsPageSection/FaqsHeaderSection";
import AboutPaladinFaqsSection from "../components/FaqsPageSection/AboutPaladinFaqsSection";
import ConsultationsFaqsSection from "../components/FaqsPageSection/ConsultationsFaqsSection";
import WorkingWithUsFaqsSection from "../components/FaqsPageSection/WorkingWithUsFaqsSection";
import ContactFaqsSection from "../components/FaqsPageSection/ContactFaqsSection";
import RequestQuoteSection from "../components/FaqsPageSection/RequestQuoteSection";

export default function FaqsPage() {
  usePageTitle("FAQs");
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="min-h-screen bg-white-pure text-black-deep">
      <main>
        <FaqsHeaderSection searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        <AboutPaladinFaqsSection searchQuery={searchQuery} />
        <ConsultationsFaqsSection searchQuery={searchQuery} />
        <WorkingWithUsFaqsSection searchQuery={searchQuery} />
        <ContactFaqsSection searchQuery={searchQuery} />
        <RequestQuoteSection />
      </main>
      <footer><Footer /></footer>
    </div>
  );
}